import React from "react";
import { useUploadQueue } from "../../contexts/UploadQueueContext";
import { aantalMislukt } from "../../contexts/uploadQueueReducer";
import { VoortgangsFab } from "../ui/VoortgangsFab";

const bestanden = (n: number) => (n === 1 ? "1 bestand" : `${n} bestanden`);

/**
 * De upload-tracker linksonder tijdens een achtergrond-upload. Wordt app-breed
 * gemount (App.tsx) zodat hij navigatie binnen de webapp overleeft; de
 * ring-knop en het detailpaneel zelf zitten in het gedeelde VoortgangsFab.
 * Per lopende baan één knop (een grote upload en daarnaast losse bestanden),
 * daarboven "In wacht (n)" en, na een onderbroken upload: Map kiezen of
 * Stoppen.
 */
export function UploadProgressFab() {
  const {
    lopend,
    wachtrij,
    gepauzeerd,
    onderbroken,
    hervatOnderbroken,
    stopOnderbroken,
  } = useUploadQueue();

  if (lopend.length === 0 && wachtrij.length === 0 && onderbroken.length === 0)
    return null;

  let stapel = 0;
  return (
    <>
      {lopend.map(
        ({
          baan,
          dossierKenmerk,
          done,
          total,
          current,
          currentFraction,
          errors,
        }) => (
          <VoortgangsFab
            key={baan}
            done={done}
            total={total}
            currentFraction={currentFraction}
            titel={`${
              baan === "groot" ? "Grote upload" : "Uploaden"
            } naar ${dossierKenmerk}`}
            huidigLabel={
              gepauzeerd
                ? "Log opnieuw in om verder te gaan"
                : current
                  ? `Bezig met "${current}"…`
                  : undefined
            }
            foutTekst={
              errors.length > 0
                ? `${
                    aantalMislukt(errors) === 1
                      ? "1 bestand mislukt"
                      : `${aantalMislukt(errors)} bestanden mislukt`
                  } — details volgen na afloop.`
                : undefined
            }
            stapelIndex={stapel++}
            positie="linksonder"
          />
        ),
      )}
      {wachtrij.length > 0 && (
        <VoortgangsFab
          done={0}
          total={wachtrij.length}
          middenTekst={String(wachtrij.length)}
          titel={`In wacht (${wachtrij.length})`}
          huidigLabel="Start zodra de upload ervoor klaar is."
          regels={wachtrij.map(
            (b) =>
              `${b.dossierKenmerk} — ${bestanden(b.aantal)}${
                b.baan === "groot" ? " (grote upload)" : ""
              }`,
          )}
          stapelIndex={stapel++}
          positie="linksonder"
        />
      )}
      {onderbroken.map((o) => (
        <VoortgangsFab
          key={o.batchId}
          done={0}
          total={1}
          middenTekst="!"
          titel="Upload onderbroken"
          huidigLabel={`${o.dossierKenmerk} — ${bestanden(o.open)} nog te gaan${
            o.heeftCd ? " (met cd)" : ""
          }`}
          foutTekst={`Upload onderbroken: kies de map opnieuw om verder te gaan.${
            o.melding ? ` ${o.melding}` : ""
          }`}
          actieKnop={{
            label: "Map kiezen",
            onClick: () => void hervatOnderbroken(o.batchId),
          }}
          sluitKnop={{
            label: "Stoppen",
            onClick: () => void stopOnderbroken(o.batchId),
          }}
          stapelIndex={stapel++}
          positie="linksonder"
        />
      ))}
    </>
  );
}
